<template>
  <div>
      <div class="amount">
    <div class="amount__counterbtn amount__counterbtn--down" @click="minus">
      <svg
        width="14"
        height="4"
        viewBox="0 0 14 4"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.005 0.525391V3.47426H0.995022V0.525391H13.005Z"
          fill="#21397D"
        />
      </svg>
    </div>
    <input
      class="amount__input"
      v-model="inputVal"
      type="text"
      @input="setFormValue" 
      name="book-counter"
    />
    <div class="amount__counterbtn amount__counterbtn--up" @click="plus">
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.49876 17.8466V0.15332H10.5012V17.8466H7.49876ZM0.153381 10.5012V7.49869H17.8466V10.5012H0.153381Z"
          fill="#21397D"
        />
      </svg>
    </div>
  </div>
  <div class="text-danger text-danger-min pt-2" v-if="value < 25">Minimalna kwota wsparcia to 25zł</div>
  </div>
</template>

<script>
export default {
  props: ["value"],
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
        set(val) {
        this.$emit('input', val);
        
      }
    },
  },
  methods: {
    minus() {
      this.$emit("minus");
    },
    plus() {
      this.$emit("plus");
    },
     setFormValue(e){
      this.$root.$emit("setFormAmountValue",  e.target.value);
    }
  },
};
</script>
<style lang="scss"></style>
